export default [
  {
    path: "/pri0d24932b286355b7881c4a116bfe5f850a43cas/:er?",
    name: "bece25.photoAlbum",
    component: () => import("@/views/bece/twf/photoalbum/index.vue"),
    meta: {
      title: "Print 2025 BECE PhotoAlbum",
      authRequired: true,
      acc: ["y50961"],
    },
  },
  {
    path: "/pri0d24932b2863b0d33dba9f60c9679236e0a0ffe5f850a43cas",
    name: "bece25.photoAlbums",
    component: () => import("@/views/bece/twf/photoalbum/list.vue"),
    meta: {
      title: "2025 BECE PhotoAlbum",
      authRequired: true,
      acc: ["y92599"],
    },
  },
];
